import { useEffect, useState } from "react";
import { useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion"

import useMount from '../../hooks/useMount';
import LoadingComponent from "../Commons/LoadingComponent";
import AlertModal from "../Commons/AlertModal";
import ConfirmModal from "../Commons/ConfirmModal";
//import useAccess from "../../hooks/useAccess";
import { setCurrentNavigation } from "../../slices/navigationSlice";
import productApi from "../../api/productApi";
import ActionButton from "../Commons/ActionButton";
import BackButton from "../Commons/BackButton";
import useLog from "../../hooks/useLog";

import { getLabel, getLanguage } from "../../tools/Dictionary";

import { MdLibraryBooks, MdErrorOutline, MdSmartToy, MdSupportAgent } from "react-icons/md";
import "./Troubleshoot.css";

const TroubleshootProduct = (props) => {

  
  //Logs
  const { logPageView } = useLog();

  //Query
  let [searchParam] = useSearchParams();

  //Navigation
  const Navigate = useNavigate();


  //Props
  const IsDesktop = props.IsDesktop;

  //Redux
  const Dispatch = useDispatch();
  //const Access = useAccess(["Trouble"]);

  //State
  const [product, setProduct] = useState({});
  const [loading, setLoading] = useState(true);
  const [alert, setAlert] = useState({
    Title: "",
    Message: "",
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });
  const [confirm] = useState({
    Title: "",
    Message: "",
    Cancel: "",
    onCancel: () => void 0,
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });


  useMount(() =>
  {
    Dispatch(setCurrentNavigation("TroubleProduct"));
    loadData();
  }, []);

  useEffect(() =>
  {
    if (product._id)
      logPageView("Troubleshoot Product", { productId: product._id, productCode: product.code });
  }, [product, logPageView]);


  const loadData = async (_showLoading = true) =>
  {

    try
    {

      let currentProduct = {
          _id: searchParam.get('product'),
        };


      //if (!currentProduct) throw new Error("");

      //Get product data from the storage
      const storageProduct = JSON.parse(localStorage.getItem("product"));

      if (_showLoading)
      {
        setLoading(true);
      }

      //If no storage data, if they product is not the same or if it has been loaded more than 10 minutes ago, load from the api. Otherwise load from storage.
      if (!storageProduct || storageProduct._id != currentProduct._id || new Date().getTime() - storageProduct.timestamp >= 600000)
      {

        let [productResponse] = await Promise.all([
          productApi.getProduct(currentProduct._id)
        ]);

        if (!productResponse.Success) throw new Error(productResponse.Error.label);

        setProduct(productResponse.Data);

        localStorage.setItem("product", JSON.stringify({ ...productResponse.Data, timestamp: new Date().getTime()}));

      }else {

        setProduct(storageProduct);


      }


      setLoading(false);

    } catch (err)
    {

      Navigate("/troubleshoot");

      setLoading(false);

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });

    }

  };

  const onClickNav = (_url) => {


    Navigate(_url);

  };
  

  return (
    <div className="page_body_cont">
      <LoadingComponent
        display={loading}
        label={getLabel("App", "Loading")}
      />
      <AlertModal
        Title={alert.Title}
        Message={alert.Message}
        Confirm={alert.Confirm}
        onConfirm={alert.onConfirm}
        Display={alert.Display}
      />
      <ConfirmModal
        Display={confirm.Display}
        Title={confirm.Title}
        Message={confirm.Message}
        Cancel={confirm.Cancel}
        onCancel={confirm.onCancel}
        Confirm={confirm.Confirm}
        onConfirm={confirm.onConfirm}
      />

      <BackButton
        Hide={IsDesktop}
      />
      {!loading && product && 
        <div className="troubleshoot_product_cont" style={{width: "600px"}}>
          <motion.div className="troubleshoot_product_row"
            variants={{ hidden: { opacity: 0.4 }, show: { opacity: 1} }}
            initial="hidden"
            animate="show"
            transition={{
              type: "tween", // Change to 'tween' for a smoother animation
              duration: 0.3, // Adjust duration as needed
              ease: "easeInOut", // Use 'easeInOut' or another easing function to remove bounce
            }}
          >
            <div className="troubleshoot_product_col_title">
              {getLabel("TroubleshootProduct", "Model")}
            </div>
            <div className="troubleshoot_product_col_value">
              {product.code || ""}
            </div>
          </motion.div>
          <motion.div className="troubleshoot_product_row"
            variants={{ hidden: { opacity: 0.3 }, show: { opacity: 1 } }}
            initial="hidden"
            animate="show"
            transition={{
              type: "tween", // Change to 'tween' for a smoother animation
              duration: 0.3, // Adjust duration as needed
              ease: "easeInOut", // Use 'easeInOut' or another easing function to remove bounce
            }}
          >
            <div className="troubleshoot_product_col_title">
              {getLabel("TroubleshootProduct", "Product")}
            </div>
            <div className="troubleshoot_product_col_value">
              {product.productFamily.label[getLanguage().code] || product.productFamily.label["EN"] || ""}
            </div>
          </motion.div>
          <motion.div className="troubleshoot_product_row"
            variants={{ hidden: { opacity: 0.2 }, show: { opacity: 1 } }}
            initial="hidden"
            animate="show"
            transition={{
              type: "tween", // Change to 'tween' for a smoother animation
              duration: 0.3, // Adjust duration as needed
              ease: "easeInOut", // Use 'easeInOut' or another easing function to remove bounce
            }}
          >
            <div className="troubleshoot_product_col_title">
              {getLabel("TroubleshootProduct", "Brand")}
            </div>
            <div className="troubleshoot_product_col_value">
              {product.brand.label[getLanguage().code] || product.brand.label["EN"] || ""}
            </div>
          </motion.div>
          {/* <motion.div className="troubleshoot_product_row"
            variants={{ hidden: { opacity: 0.1 }, show: { opacity: 1 } }}
            initial="hidden"
            animate="show"
            transition={{
              type: "tween", // Change to 'tween' for a smoother animation
              duration: 0.3, // Adjust duration as needed
              ease: "easeInOut", // Use 'easeInOut' or another easing function to remove bounce
            }}
          >
            <div className="troubleshoot_product_col_title">
              {getLabel("TroubleshootProduct", "Category")}
            </div>
            <div className="troubleshoot_product_col_value">
              {product.productCategory.label[getLanguage().code] || product.productCategory.label["EN"] || ""}
            </div>
          </motion.div> */}
          <div className="troubleshoot_product_row_center" style={{ marginTop: "10px" }}>
            <div className="troubleshoot_product_row_line" />
          </div>
          {product.productFile.length > 0 &&
            <motion.div 
            className="troubleshoot_product_row_center" style={{marginTop: "20px"}}
              variants={{ hidden: { opacity: 0, scale: 0.95 }, show: { opacity: 1, scale: 1 } }}
              initial="hidden"
              animate="show"
            >
              <ActionButton
                IsDesktop={true}
                Label={getLabel("TroubleshootProduct", "Documentation")}
                Icon={MdLibraryBooks}
                Disabled={loading}
                OnClick={() => onClickNav(`/troubleshoot/product/file?product=${product._id}`)}
              />
            </motion.div>
          }
          {product.process && 
            <motion.div className="troubleshoot_product_row_center" style={{ marginTop: "20px" }}
              variants={{ hidden: { opacity: 0, scale: 0.95 }, show: { opacity: 1, scale: 1 } }}
              initial="hidden"
              animate="show"
            >
              <ActionButton
                IsDesktop={true}
                Label={getLabel("TroubleshootProduct", "Troubleshooting")}
                Icon={MdErrorOutline}
                Disabled={loading}
                OnClick={() => onClickNav(`/troubleshoot/product/process?product=${product._id}&process=${product.process._id}`)}
              />
            </motion.div>
          }

          { product.virtualAssistant &&
            <motion.div className="troubleshoot_product_row_center" style={{ marginTop: "20px" }}
              variants={{ hidden: { opacity: 0, scale: 0.95 }, show: { opacity: 1, scale: 1 } }}
              initial="hidden"
              animate="show"
            >
              <ActionButton
                IsDesktop={true}
                Label={getLabel("TroubleshootProduct", "Virtual Assistant")}
                Icon={MdSmartToy}
                Disabled={loading}
                OnClick={() => onClickNav(`/troubleshoot/product/virtual?product=${product._id}`)}
              />
            </motion.div>
          }
          <motion.div className="troubleshoot_product_row_center" style={{ marginTop: "20px" }}
            variants={{ hidden: { opacity: 0, scale: 0.95 }, show: { opacity: 1, scale: 1 } }}
            initial="hidden"
            animate="show"
          >
            <ActionButton
              IsDesktop={true}
              Label={getLabel("TroubleshootProduct", "Customer Support")}
              Icon={MdSupportAgent}
              Disabled={loading}
              OnClick={() => onClickNav(`/contact?product=${product._id}&productCode=${product.code}`)}
            />
          </motion.div>
        </div>
      }
    </div>
  );

};

export default TroubleshootProduct